export const SearchDirection = {
    From: 'from',
    To: 'to',
};
Object.setPrototypeOf(SearchDirection, null);
